import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const b = window.sessionStorage.getItem("mc_building");
  if (b) {
    config.params = { ...(config.params || {}), b };
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const orig = error.config;
    if (
      error.response?.status === 401 &&
      orig &&
      !orig._retry &&
      !orig.url.includes("/auth/login") &&
      !orig.url.includes("/auth/refresh") &&
      !orig.url.includes("/auth/me")
    ) {
      orig._retry = true;
      try {
        await api.post("/auth/refresh");
        return api(orig);
      } catch (e) {
        /* session expirée */
      }
    }
    return Promise.reject(error);
  }
);

export function fileUrl(path) {
  return `${process.env.REACT_APP_BACKEND_URL}/api/files/${path}`;
}

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : "")).filter(Boolean).join(" ");
  return "Une erreur est survenue. Réessayez.";
}

export default api;
